<template>
  <a-modal :visible="visible" :footer="null" :closable="false" width="420px" centered>
    <div class="done-body" @keydown="handleKey">
      <a-icon type="check-circle" class="done-icon" />
      <div class="done-title">结算成功</div>
      <div class="done-amount">¥{{ format(result.total) }}</div>
      <div class="done-info">
        <div>单号：{{ result.billNo }}</div>
        <div>支付：{{ result.payType }}</div>
        <div v-if="result.change > 0">找零：¥{{ format(result.change) }}</div>
      </div>
      <div class="done-actions">
        <a-button @click="printReceipt">打印小票</a-button>
        <a-button type="primary" @click="nextOrder">下一单（回车）</a-button>
      </div>
    </div>
    <!-- 小票打印区（仅打印时可见） -->
    <div id="pos-receipt-print" class="receipt-print" v-if="receipt">
      <div class="r-center r-bold">{{ receipt.shopName || '零售小票' }}</div>
      <div class="r-center">单号：{{ receipt.number }}</div>
      <div class="r-center">时间：{{ receipt.operTime }}</div>
      <div v-if="receipt.memberName" class="r-center">会员：{{ receipt.memberName }}（{{ receipt.levelName || '会员' }}）</div>
      <div class="r-line">--------------------------------</div>
      <div v-for="(item, i) in receipt.items" :key="i" class="r-item">
        <div>{{ item.material_unit }} × {{ item.oper_number }} × {{ item.unit_price }}</div>
        <div class="r-right">¥{{ item.all_price }}</div>
      </div>
      <div class="r-line">--------------------------------</div>
      <div class="r-item r-bold">
        <span>合计：¥{{ receipt.total_price }}</span>
      </div>
      <div class="r-item"><span>支付：{{ receipt.pay_type }}</span></div>
      <div class="r-center r-tip">谢谢惠顾，欢迎再次光临</div>
    </div>
  </a-modal>
</template>

<script>
  import { cashierReceipt } from '@/api/plugin/member'

  /**
   * 完成反馈：金额/单号/找零，回车或点击开启下一单；支持打印小票
   */
  export default {
    name: 'ReceiptDone',
    props: {
      visible: { type: Boolean, default: false },
      result: { type: Object, default: () => ({}) }
    },
    data() {
      return {
        receipt: null
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.receipt = null
          this.loadReceipt()
          document.addEventListener('keydown', this.handleKey)
        } else {
          document.removeEventListener('keydown', this.handleKey)
        }
      }
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKey)
    },
    methods: {
      format(price) {
        return Number(price || 0).toFixed(2)
      },
      loadReceipt() {
        if (!this.result.headId) {
          return
        }
        cashierReceipt(this.result.headId).then(res => {
          if (res && res.code === 200) {
            this.receipt = res.data
          }
        })
      },
      handleKey(e) {
        if (e.key === 'Enter') {
          this.nextOrder()
        }
      },
      nextOrder() {
        this.$emit('next')
      },
      printReceipt() {
        if (!this.receipt) {
          this.$message.warning('小票数据加载中，请稍候')
          return
        }
        const printArea = document.getElementById('pos-receipt-print')
        if (!printArea) {
          return
        }
        const win = window.open('', '_blank', 'width=380,height=600')
        win.document.write('<html><head><title>零售小票</title><style>' +
          'body{font-family:"SimSun",monospace;font-size:12px;width:300px;margin:0 auto;}' +
          '.r-center{text-align:center;}.r-bold{font-weight:bold;}' +
          '.r-right{text-align:right;}.r-item{display:flex;justify-content:space-between;}' +
          '.r-line{margin:4px 0;} .r-tip{margin-top:8px;}' +
          '</style></head><body>' + printArea.innerHTML + '</body></html>')
        win.document.close()
        win.focus()
        win.print()
        win.close()
      }
    }
  }
</script>

<style scoped>
  .done-body {
    text-align: center;
    padding: 10px 0;
  }
  .done-icon {
    font-size: 52px;
    color: #52c41a;
  }
  .done-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-top: 10px;
  }
  .done-amount {
    font-size: 36px;
    color: #e4393c;
    font-weight: 700;
    margin: 8px 0;
  }
  .done-info {
    color: #888;
    font-size: 13px;
    line-height: 1.9;
  }
  .done-actions {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 12px;
  }
  .receipt-print {
    display: none;
  }
</style>
